import { NgModule } from '@angular/core';
import { NgbitIndeterminateBarComponent } from './ngbit-indeterminate-bar.component';
import { CommonModule } from '@angular/common';

@NgModule({
    imports: [CommonModule],
    declarations: [NgbitIndeterminateBarComponent],
    exports: [NgbitIndeterminateBarComponent]
})
export class NgbitIndeterminateBarModule { }
